<template>
  <div class="container">
    <div class="auTop minBox">
      <div class="auTopTitle"></div>
    </div>
    <div class="content">
      <div class="tabTitle maxBox">
        <div class="titleItem" :class="{titleActive:tabIndex===1}" @click="tabToggle(1)">企业简介</div>
        <div class="titleItem" :class="{titleActive:tabIndex===2}" @click="tabToggle(2)">发展历程</div>
        <div class="titleItem" :class="{titleActive:tabIndex===3}" @click="tabToggle(3)">企业文化</div>
        <div class="titleItem" :class="{titleActive:tabIndex===4}" @click="tabToggle(4)">联系我们</div>
      </div>
      <tab-item1 v-show="tabIndex===1"/>
      <tab-item2 v-show="tabIndex===2"/>
      <tab-item3 v-show="tabIndex===3"/>
      <tab-item4 v-show="tabIndex===4"/>
    </div>
  </div>
</template>
<script>
import TabItem1 from './components/tabItem1'
import TabItem2 from './components/tabItem2'
import TabItem3 from './components/tabItem3'
import TabItem4 from './components/tabItem4'
export default {
  name: 'aboutUs',
  components:{
    TabItem1,
    TabItem2,
    TabItem3,
    TabItem4
  },
  data () {
    return {
      tabIndex:1
    }
  },
  methods: {
    tabToggle(num){
      this.tabIndex = num;
    }
  },
}
</script>
<style lang="scss">
@import '@/assets/css/index.scss';
.aboutSectionTitleC{
  text-align: center;
  .titleLine{
    margin: 30px auto 0;
  }
}
  .aboutSectionTitle {
    .CNtitle {
      font-size: 24px;
      color: #333;
    }
    .ENtitle {
      font-size: 12px;
      font-family: Helvetica;
      color: #666;
      margin-top: 10px;
    }
    .titleLine {
      width: 50px;
      height: 4px;
      background: $aboutRed;
      margin-top: 30px;
    }
  }
</style>
<style lang="scss" scoped>
.container{
  padding-top: 60px;
  .auTop {
    width: 100%;
    height: 400px;
    background: url("~@/assets/img/aboutUs/topBanner.png") no-repeat center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    .auTopTitle{
      width: 224px;
      height: 134px;
      background: url("~@/assets/img/aboutUs/topIcon.png") no-repeat center;
      background-size: cover;
    }
  }
  .content{
    .tabTitle{
      background: #F4F4F4;
      display: flex;
      justify-content: center;
      .titleItem{
        width: 300px;
        line-height: 60px;
        text-align: center;
        font-size:18px;
        color: #666;
        cursor: pointer;
      }
      .titleActive{
        background: #D5262B;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/aboutUs/main.vue